module.exports = __webpack_public_path__ + "img/kartoffelsalat.a41221bc.png";